{
  "heading": "Schedule settings",
  "timezone_label": "Time zone",
  "timezone_hint": "All events will be displayed in this time zone",
  "update_successful": "✨ Update successful!",
  "error_slug": "This slug cannot be used. Please choose a different one.",
  "error_generic": "Error saving settings. Please try again.",
  "slug_label": "Slug",
  "slug_hint": "Only lowercase letters, numbers, and hyphens are allowed.",
  "slug_invalid": "Invalid slug",
  "social_sharing_label": "Magic social sharing",
  "social_sharing_hint": "On magic share pages, turn the 'copy link' button into a social share widget",
  "social_sharing_enabled": "Enabled",
  "social_sharing_disabled": "Disabled",
  "description_label": "Description",
  "submit": "Save"
}
